import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-758e83a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-footer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "Copyright 2023", -1))
const _hoisted_3 = { class: "font-bold ml-2" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.app_base_data.app_name), 1),
    _createElementVNode("small", null, "(v " + _toDisplayString(_ctx.app_base_data.version) + ")", 1)
  ]))
}